// mutationHelpers.js
const KEY_DATA_TABLE = 'dataTable';
export const handleMutationSuccess = ({
  data,
  queryClient,
  setShowModalApproveRequest,
  showToast,
  setFilter,
  view,
  t
}) => {
  if (data.data.result === 'success') {
    queryClient.invalidateQueries([KEY_DATA_TABLE]);
    setShowModalApproveRequest(false);
    showToast({ visible: true, message: t(`requestVacancies.colaborativeSelection.approveRequest`) });
    if (setFilter) {
      setFilter((prev) => {
        return { ...prev, pageIndex: 0 };
      });
    }
    window.location.href = data.data.shortUrlVacancy;
  } else if (data.data.result === 'error') {
    showToast({ visible: true, type: 'error', message: t(`general.error.support`) });
  }
};

export const handleMutationModify = ({
  data,
  queryClient,
  setShowModalModifyRequest,
  view,
  showToast,
  setFilter,
  t
}) => {
  if (data.data.result === 'success') {
    queryClient.invalidateQueries([KEY_DATA_TABLE]);
    setShowModalModifyRequest(false);
    showToast({ visible: true, message: t(`requestVacancies.colaborativeSelection.modifyRequest`) });
    if (setFilter) {
      setFilter((prev) => {
        return { ...prev, pageIndex: 0 };
      });
    }
    if (view === 'formRequest') {
      window.location.href = `/app/vacancy_request`;
    }
  }
  if (data.data.result === 'error') showToast({ visible: true, type: 'error', message: t(`general.error.support`) });
};

export const handleMutationReject = ({
  data,
  queryClient,
  setShowModalRejectRequest,
  view,
  showToast,
  setFilter,
  t
}) => {
  if (data.data.result === 'success') {
    queryClient.invalidateQueries([KEY_DATA_TABLE]);
    setShowModalRejectRequest(false);
    showToast({ visible: true, message: t(`requestVacancies.colaborativeSelection.rejectRequest`) });
    if (setFilter) {
      setFilter((prev) => {
        return { ...prev, pageIndex: 0 };
      });
    }
    if (view === 'formRequest') {
      window.location.href = `/app/vacancy_request`;
    }
  }

  if (data.data.result === 'error') showToast({ visible: true, type: 'error', message: t(`general.error.support`) });
};

export const handleMutationDelete = ({
  data,
  queryClient,
  setShowModalDeleteRequest,
  view,
  showToast,
  setFilter,
  t
}) => {
  queryClient.invalidateQueries([KEY_DATA_TABLE]);
  setShowModalDeleteRequest(false);
  showToast({ visible: true, message: t(`requestVacancies.colaborativeSelection.deleteRequest`) });
  if (setFilter) {
    setFilter((prev) => {
      return { ...prev, pageIndex: 0 };
    });
  }
  if (view === 'formRequest') {
    window.location.href = `/app/vacancy_request`;
  }
  if (data.data.result === 'error') showToast({ visible: true, type: 'error', message: t(`general.error.support`) });
};
